import { Injectable } from '@angular/core';
import { Motivo } from '../interfaces/motivos';

@Injectable({
  providedIn: 'root'
})
export class MotivosService {
private motivos:Motivo[]=new Array;
  constructor() {
    this.motivos.push({id:1, motivo:'Cerrado/Ausente 1ra visita'});
    this.motivos.push({id:2, motivo:'Cerrado/Ausente 2da visita'});
    this.motivos.push({id:3, motivo:'Direccion inexistente'});
    this.motivos.push({id:4, motivo:'Se mudo'});
    this.motivos.push({id:5, motivo:'Rechazado'});
    this.motivos.push({id:6, motivo:'Plazo vencido no reclamado'});
    this.motivos.push({id:7, motivo:'Direccion isuficiente'});
    this.motivos.push({id:8, motivo:'Direccion Inaccesible'});
    this.motivos.push({id:9, motivo:'Rescatada'});
    this.motivos.push({id:10, motivo:'Cumplido sin exito'});


  }
  get(){
    return this.motivos;
  }
}
